(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomercDialogController', EntregasafracomercDialogController);

    EntregasafracomercDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Entregasafracomerc', 'Safra', 'Etapa', 'Principal'];

    function EntregasafracomercDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Entregasafracomerc, Safra, Etapa, Principal) {
        var vm = this;

        vm.entregasafracomerc = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'entregasafracomerc-is-null'});
        $q.all([vm.entregasafracomerc.$promise, vm.safras.$promise]).then(function() {
            if (!vm.entregasafracomerc.safra || !vm.entregasafracomerc.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.entregasafracomerc.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "entregasafracomerc";
            vm.etapa.safra = vm.entregasafracomerc.safra;
            
            if (vm.entregasafracomerc.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.entregasafracomerc.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.entregasafracomerc.etapa = new Etapa();
            vm.entregasafracomerc.etapa = result;
            Entregasafracomerc.save(vm.entregasafracomerc, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.entregasafracomerc.etapa = new Etapa();
            vm.entregasafracomerc.etapa = result;
            Entregasafracomerc.update(vm.entregasafracomerc, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:entregasafracomercUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datafim = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
